export default __webpack_public_path__ + "static/media/puppy.a03c1cd9.svg";